import { Navbar } from "@/components/Navbar";
import { PageBackground } from "@/components/PageBackground";
import { Mail, HelpCircle, ShieldCheck, MessageSquare } from "lucide-react";

const FAQS = [
  { q: "How does RentMatch work?", a: "Verified tenants build a profile once, then receive rental offers directly from landlords — no more chasing listings." },
  { q: "How does our matching algorithm work?", a: "We match verified, actively-searching tenants to properties using three signals: (1) location — properties within your chosen search distance of your address (or your preferred areas); (2) amenities — a property must cover at least 75% of your must-have amenities; and (3) fit — minimum bedrooms/bathrooms and your budget range. Landlords see the same match quality when browsing tenants, so both sides only see genuinely relevant matches." },
  { q: "How do I get verified?", a: "Open your tenant dashboard and tap Verify. The first 100 tenants verify free; after that it's a one-time $24.99 that runs background, credit, income and ID checks." },
  { q: "Why can't I message a landlord yet?", a: "Messaging unlocks once a landlord sends you an offer. That keeps conversations relevant and spam-free." },
  { q: "How do I pause or resume matchmaking?", a: "Use the toggle on your dashboard. Resuming after a pause runs a fresh $10 credit check so landlords always see current info." },
  { q: "How do I delete my account or data?", a: "Email myrentalmatch@gmail.com and we'll remove your account and associated data." },
];

export default function Support() {
  return (
    <div className="min-h-screen">
      <PageBackground variant={2} />
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-12" data-testid="support-page">
        <h1 className="font-display text-4xl font-semibold tracking-tight">Support</h1>
        <p className="text-muted-foreground mt-2">We're here to help you find your next home.</p>

        <div className="mt-8 grid sm:grid-cols-2 gap-4">
          <a href="mailto:myrentalmatch@gmail.com" data-testid="support-email"
             className="bg-white border border-border rounded-sm p-5 flex items-center gap-3 hover:border-primary transition-colors">
            <span className="grid place-items-center w-10 h-10 rounded-sm bg-primary/10 text-primary"><Mail className="w-5 h-5" /></span>
            <div>
              <div className="font-semibold">Email us</div>
              <div className="text-sm text-muted-foreground">myrentalmatch@gmail.com</div>
            </div>
          </a>
          <div className="bg-white border border-border rounded-sm p-5 flex items-center gap-3">
            <span className="grid place-items-center w-10 h-10 rounded-sm bg-primary/10 text-primary"><MessageSquare className="w-5 h-5" /></span>
            <div>
              <div className="font-semibold">Response time</div>
              <div className="text-sm text-muted-foreground">Typically within 1 business day</div>
            </div>
          </div>
        </div>

        <h2 className="font-display text-2xl font-semibold tracking-tight mt-12 mb-4 flex items-center gap-2">
          <HelpCircle className="w-5 h-5 text-primary" /> Frequently asked questions
        </h2>
        <div className="space-y-4">
          {FAQS.map((f) => (
            <div key={f.q} className="bg-white border border-border rounded-sm p-5">
              <div className="font-semibold">{f.q}</div>
              <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{f.a}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center gap-2 text-sm text-muted-foreground">
          <ShieldCheck className="w-4 h-4 text-primary" />
          Read our <a href="/privacy" className="text-primary font-medium">Privacy Policy</a>.
        </div>
      </div>
    </div>
  );
}
